<div class="menubar-wrapper">
  <p-menubar [model]="items" [breakpoint]="menuBreakpoint" 
    [ngClass]="{'collapsed': isCollapsed(), 'fade': showMenuFade}"
    *ngIf="showMenu">
    <!-- logo -->
    <ng-template #start>
      <img class="logo" [src]="logo" alt="logo" *ngIf="logo">
    </ng-template>
    <!-- main navigation menu -->
    <ng-template  #item let-item>
      <ng-container *ngIf="item.route; else urlRef">
        <a [routerLink]="item.route" class="p-menubar-item-link" 
          [ngClass]="{'p-menubar-item-link-active': item.isActive()}">
          <span [class]="item.icon"></span>
          <span>{{ item.label }}</span>
        </a>
      </ng-container>
      <ng-template #urlRef>
        <a *ngIf="item.url; else noLink" [href]="item.url" class="p-menubar-item-link">
          <span [class]="item.icon"></span>
          <span>{{ item.label }}</span>
        </a>
      </ng-template>
      <ng-template #noLink>
        <div class="p-menubar-item-link">
          <span [class]="item.icon"></span>
          <span>{{ item.label }}</span>
          <span class="pi pi-fw pi-angle-down"></span>
        </div>
      </ng-template>
    </ng-template>
    <!-- filters / settings -->
    <ng-template #end>
      <div class="p-menubar-settings">
        <form class="filters" [formGroup]="form" *ngIf="form">
          <app-form-input-dropdown [options]="tenants" [optionsField]="'name'" [noLabel]="true" [appendTo]="'body'" [clearable]="false"
            [filter]="false" [field]="'tenant'" [formControl]="f['tenant']" formControlName="tenant"
            [placeholder]="'field.tenant' | translate"></app-form-input-dropdown>
        </form>
        <span class="username">{{ username | titlecase }}</span>
        <div class="user-settings clickable" (click)="menu.toggle($event)">
          <span class="pi pi-user"></span>
          <span class="pi pi-fw pi-angle-down"></span>
        </div>
        <div class="dev" *ngIf="isDev">DEV</div>
      </div>
      <p-menu #menu [model]="itemsUser" [popup]="true">
        <ng-template pTemplate="item" let-item>
          <ng-container [ngSwitch]="item.action">
            <!-- break begin template -->
            <a class="p-menuitem-link" *ngSwitchCase="'break_begin'">
              <div>
                <span [class]="item.icon"></span>
                <span class="text-sm">
                  {{ 'break-from' | translate:{ time: item.record } }}
                </span>
              </div>
              <span class="fa fa-coffee end" [pTooltip]="'button.break-end' | translate"
                tooltipEvent="hover" tooltipPosition="top"
                (click)="createTimesheetRecord('break_end'); $event.stopPropagation();"></span>
            </a>
            <!-- work begin template -->
            <a *ngSwitchCase="'work_begin'" class="p-menuitem-link">
              <div>
                <span [class]="item.icon"></span>
                <span class="text-sm">
                  {{ 'init-at' | translate:{ time: item.record } }}
                </span>
              </div>
              <div>
                <span class="pi pi-stop" [pTooltip]="'button.end' | translate"
                  tooltipEvent="hover" tooltipPosition="top"
                  (click)="createTimesheetRecord('work_end'); $event.stopPropagation();"></span>
                <span class="pi fa fa-coffee begin" [pTooltip]="'button.break-begin' | translate"
                  tooltipEvent="hover" tooltipPosition="top"
                  (click)="createTimesheetRecord('break_begin'); $event.stopPropagation();"></span>
              </div>
            </a>
            <!-- default item template -->
            <a *ngSwitchDefault class="p-menuitem-link">
              <div>
                <span [class]="item.icon"></span>
                <span class="p-menuitem-text">{{ item.label }}</span>
              </div>
              <span class="pi pi-play" [pTooltip]="'button.init-work' | translate"
                tooltipEvent="hover" tooltipPosition="top"
                (click)="createTimesheetRecord('work_begin'); $event.stopPropagation();" 
                *ngIf="item.timesheet"></span>
            </a>
          </ng-container>
        </ng-template>
      </p-menu>
    </ng-template>
  </p-menubar>
</div>
